import type { FirebasePurchaseScene } from "./types";

/**
 * 呼び出し元（ポイント不足シート／クイックチャージシート）が持つシーン値の語彙。
 * InsufficientPointScene(chat/video/voice/live/gift/image/movie/audio) と
 * QuickChargeScene(live/video/voice) はいずれもこの部分集合。
 */
type PurchaseSceneSource =
  | "chat"
  | "video"
  | "voice"
  | "live"
  | "gift"
  | "image"
  | "movie"
  | "audio";

const PURCHASE_SCENE_MAP: Record<PurchaseSceneSource, FirebasePurchaseScene> = {
  video: "videocall",
  voice: "voicecall",
  chat: "chat",
  live: "live",
  gift: "gift",
  image: "media_image",
  movie: "media_video",
  audio: "media_audio",
};

/**
 * 呼び出し元のシーン値を Firebase の paywall_view / purchase_plan_tap /
 * pt_zero_reached.last_action 用の語彙へ変換する。未指定なら undefined
 * （通常の /purchase ページ由来を表す）。
 */
export const toFirebasePurchaseScene = (
  scene: PurchaseSceneSource | undefined,
): FirebasePurchaseScene | undefined => {
  return scene ? PURCHASE_SCENE_MAP[scene] : undefined;
};
